module.exports = __webpack_public_path__ + "static/media/intro.b98c52c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/intro.svg
// module id = 80
// module chunks = 0